export const IBEXA_RESPONSIVE_IMAGE_ENDPOINT = "/api/ibexa/v2/responsive-image";
export const IBEXA_SEARCH_ENDPOINT = "/api/ibexa/v2/search";
export const IBEXA_CONTENT_ITEM_ENDPOINT = "/api/ibexa/v2/content/objects/";
export const IBEXA_PRODUCT_PREVIEW = "/api/ibexa/v2/product-preview/";
